const now = Date.now() / 1000

function initialState() {
	return {
		sc: 1,
		locale: 'de',
		userTheme: 'dark',
		user: {
			accessToken: '',
			_id: '',
			email: '',
			role: '',
		},
		showLoginModal: false,
		wsConnected: false,

		allStates: {
			projects: {},
			locations: {},
			hubs: {},
			modules: {},
			comapps: {},
		},

		users: [],
		customGraphs: [],
		modules: [],
		hubs: [],
		locations: [],
		projects: [],
		sundata: [],
		inventoryList: [],
		inventoryMeta: {},

		comapps: {
			storage: [],
			data: [],
		},

		alerts: {},
		warns: {},

		// d3Data: {extentX: ['',''],},
		d3Data: { from: Math.round(now - 60 * 60 * 24 * 14), to: Math.round(now + 60 * 60 * 24 * 3) },
		// d3DataExtentXFrom:'',
		// d3DataExtentXTo:'',

		wsCount: 0, // count ws user connections

		svgZoom: 1,
		svgMoveX: 1,
		svgMoveY: 1,

		version: '',
		mapBoxKey: 'pk.eyJ1IjoicHJvcGVsbGVyY2F0IiwiYSI6ImNrcWRidmJkODBibncydnBlZHh0dXNuN2QifQ.F7n9o77X0SiIjwPWXMz_iA',

		// from router
		locationIdRoute: '',
		hubIdRoute: '',
		modulIdRoute: '',
		projectIdRoute: '',
		projectIdCalculated: '',
		comappIdRoute: '',

		lastUpdateTriggerHub: '',

		// svg graphs
		_svgTools: {},

		// ws - yocto live set data
		tempYoctos: [],
		currentYoctoData: {},
		currentYoctoId: '',
	}
}
export default initialState
